import type { NextPage } from 'next'
import { getTextColor, joinClassnames } from 'helpers/classNames'
import { Size } from 'types/size'
import styles from './Subtitle.module.scss'
import { Type } from 'types/type'

interface Props {
  text: string
  color?: string
  size?: Size
  type?: Type
  noMargin?: boolean
  noWrap?: boolean
  alignLeft?: boolean
  alignRight?: boolean
  normalWeight?: boolean
  fitContent?: boolean
  underline?: boolean
}

const Subtitle: NextPage<Props> = (props: Props) => {
  const color = props.color ? props.color : ''

  const className = joinClassnames([
    styles.subtitle_text,
    props.size === Size.xxxSmall && styles.xxxSmall,
    props.size === Size.xxSmall && styles.xxSmall,
    props.size === Size.xSmall && styles.xSmall,
    props.size === Size.small && styles.small,
    props.size === Size.medium && styles.medium,
    props.size === Size.large && styles.large,
    props.noWrap && styles.nowrap,
    props.noMargin && styles.no_margin,
    props.alignLeft && styles.alignLeft,
    props.alignRight && styles.alignRight,
    props.normalWeight && styles.normalWeight,
    props.fitContent && styles.fitContent,
    props.underline && styles.underline,
  ])

  const textColorStyle = getTextColor(props.type)

  return (
    <div className={`${props.fitContent ? styles.fitContent : styles.subtitle_container}`}>
      <div className={`${className} ${textColorStyle}`} style={{ color: color }}>
        {props.text}
      </div>
    </div>
  )
}

export default Subtitle
